<template>
  <fragment>
    <b-button v-if="!programmatic" class="button" @click="openGallary"
      >Select Image</b-button
    >
    <mc-image-select
      v-bind="$attrs"
      :open="isGallaryOpen"
      @close="closeGallary"
      @input="selectImage"
    />
  </fragment>
</template>

<script>
import { default as McImageSelect } from './Select';
export default {
  components: {
    McImageSelect
  },
  inheritAttrs: false,
  props: {
    programmatic: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isGallaryOpen: false
    };
  },
  methods: {
    selectImage(url) {
      this.closeGallary(true);
      this.$emit('input', url);
    },
    closeGallary(onInput) {
      this.isGallaryOpen = false;
      if (!onInput) this.$emit('close');
    },
    openGallary() {
      this.isGallaryOpen = true;
    }
  }
};
</script>
